<template>
  <div class="shop-select">
    <Checkbox
      :list.sync="shopList"
      :select-list.sync="selectShop"
      :already="already"
      @updateCheck="updateCheck"
    />
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue'
export default {
  name: '',
  components: {
    Checkbox
  },
  props: {
    init: Boolean
  },
  data() {
    return {
      shopList: [],
      selectShop: [],
      already: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getMyShopList()
  },
  methods: {
    async getMyShopList() {
      const ret = await this.$http.getMyShopList()
      if (ret.code == 200) {
        this.shopList = ret.data.map(e => {
          return { text: e.name, value: e.id }
        })
        if (this.init) {
          this.already = true
        }
      }
    },
    updateCheck(val) {
      this.selectShop = val
      this.$emit('updateShop', this.selectShop)
    }
  }
}
</script>
<style lang="scss" scoped>
.shop-select {
  ::v-deep .checkbox-item {
    width: 150px !important;
    margin-bottom: 20px;
  }
}
</style>
